
<!-- 智能电力//建筑能耗  -->
<template>
  <div class="box">
    <Title
      :text="maintain.BuildingEnergyConsumption.Title[0]"
      :engText="maintain.BuildingEnergyConsumption.Title[1]"
    ></Title>
    <div class="content">
      <div class="a1">
        [
        <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">
          本日
        </div>
        <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">
          本月
        </div>
        <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">
          本年
        </div>
        ]
      </div>
      <div class="a2">
        <div class="echarts-content">
            <chart-block ref="echart"></chart-block>
          </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Title from "../../components/title/index.vue";
import { mapState, mapActions } from "pinia"; //引入映射函数
import useStore from "@/store/index"; //引入store
export default {
  components: {
    Title,
  },
  data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  computed: {
    ...mapState(useStore, ["maintain"]),
  },
  mounted () {
      this.$refs.echart.setOption(this.maintain.BuildingEnergyConsumption.data[this.active - 1]);
  },
  methods: {
    fn1(i){
      this.active = i;
      this.$refs.echart.setOption(this.maintain.BuildingEnergyConsumption.data[this.active - 1]);
    }
  }
};
</script>
  
  <style scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background-color: red; */
}
.content .a1 {
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content .a1 > div {
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.content .a2 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
</style>